import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

export const custPaymentsService = {
    getItems,
    getItemsRemote,
    getRejectedItems,
    setStatus,
    getExportFiles,
    getExportRows,
    scheduleExport,
    getRejectReasons,
    getStatusHistory
}

function getItems() {
    return axios.get(API_BASE_URL + '/api/admin/v1/custpayments/gettopay')
}

function getItemsRemote() {
    const config = {
        headers: {
            'X-Api-Key': '1A8FE4D2-E6C6-480F-B23D-D6CA8D31A601'
        }
    };
    return axios.get('http://localhost:7247/api/SearchItems', config)
}

function getRejectedItems() {
    return axios.get(API_BASE_URL + '/api/admin/v1/custpayments/rejected')
}

function setStatus(payload) {
    return axios.post(API_BASE_URL + '/api/admin/v1/custpayments/setstatus', payload)
}

function getExportFiles(payload) {
    return axios.post(API_BASE_URL + '/api/admin/v1/custpayments/getexportfiles', payload)
}

function scheduleExport(payload) {
    return axios.post(API_BASE_URL + '/api/admin/v1/custpayments/scheduleexport', payload)
}

function getExportRows(payload) {
    return axios.get(API_BASE_URL + '/api/admin/v1/custpayments/downloadexport/' + payload)
}

function getRejectReasons() {
    return axios.get(API_BASE_URL + '/api/admin/v1/custpayments/getrejectreasons')
}

function getStatusHistory(payload) {
    return axios.get(API_BASE_URL + '/api/admin/v1/custpayments/getstatushistory/' + payload.id)
}